import LocalizedStrings from 'react-localization';
let strings = new LocalizedStrings({
  en: {
    //LOGIN
    SignEmail: "Email",
    SignPass: "Password",
    loginBtn: 'Login',
    signupQues: "You don't have account?",
    signup: "Signup",
    forgetQues: "Forget your password?",
    signinQues: "Do you have account? Login",
    viewAsVisitor: "View as visitor",
    chooseLevel: "Choose Level",
    Continue: "Continue",
    public: "Public",
    onlyMe: "Only Me",
    defult: "Select Privacy",

    // Header
    LogoutBTN: "Logout",
    ArabicBTN: "Arabic",
    EnglishBTN: "English",
    loadBTN: "Show All",
    AllNotifications: "All Notifications",
    SearchInput: "Search",
    JoinBTN: "Join",
    noMessages: "There are no Messages",
    noNotifications: "There's  no Notifications",
    logout: "Logout",
    confirmation: "Are you sure you want to Logout",
    confirm: "Logout",
    CancelBTN: "Cancel",
    accept: "accept",
    reject: "reject",
    // DatesSideNav
    Dates: "Appointements",
    Saturday: "Saturday",
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    day: "Today",

    // AccoutnSideNav
    AccountBTN: "My Account",
    Buslist: "Business List",
    Level: "Levels",
    stlevel: "First Secondary",
    ndlevel: "Second Secondary",
    thlevel: "Third Secondary",
    addlevel: "Add Level",
    Students: "Students",
    Assistants: "Assistants",
    Settings: "Settings",

    // Levels
    LevelName: "Level",
    groups: "Groups",
    exams: "Exams",
    explain: "Explanation",
    AddSubject: "Add Subject",
    subject: "Subject",
    submit: "Submit",
    noSubject: "There's no subject",

    //ASSISTANTS
    Allassistant: "All assistants",
    Assistant: "Assistant",
    addAssistant: "Add assistant",
    sendMessage: "Send message",
    EditData: "Editing data",
    AddExam: "Add exam",
    examCorr: "Correct exam",
    AddStudent: "Add student",
    EditStudent: "Edit students' data",
    noGroups: "There's no groups for this assistant",
    editAssistant: "Edit assistant's data",
    save: "Save",
    deleteAssis: "Delete account",
    deleteAssisQ: "Do you want to delete this assistant ?",
    noAssistant: "There's no Assistants",
    deleteMsg: "Delete",
    // Settings
    settingsTitle: "Settings",
    personalinformation: "Personal Information",
    changePassword: "Change Password",
    deleteAccount: "Delete Account",
    SaveSettings: "Save Settings",
    confirmDelete: "Confirmation Delete Account ?",
    cancelBTN: "Cancel",
    confirmBTN: "Delete",
    myAccount: "My Account",
    followersNum: "Followers",
    notesNum: "Notes",
    VideosNum: "Videos",
    QuestionsNum: "Questions",

    // ToDo
    myToDoTitle: "My ToDo List",
    AddToDo: "Add ToDo",
    add: "Add",
    confirmFinishTask: "Are you sure you want to finish  Task",
    confirmUnFinishTask: "Are you sure you want to unfinish  Task",
    finish: "Finish",
    unfinish: "unfinish",
    questionMark: "?",
    tasksExist: "There are no tasks to finish today",
    AllassistantToDO: "Assistants ToDo",
    finished: "Finished",
    notFininshed: "Not Finished",
    errorMsg: "Please Choose Assistant to add to them Tasks",
    lectApp: "Lecture appointment",
    examApp: "Exam appointment",
    noAppoint: "There's no appointment",
    AllStudentsToDo: "Students ToDo",
    student: "Student",

    // GROUPs
    chooseAssistant: "Choose Assistant",
    students: 'Students',
    assistants: 'Assistants',
    extraLec: 'Extra lectures',
    details: 'Details',
    parent: "Parent",
    results: "Results",
    conversation: "Conversation",
    moveGroup: "Move group",
    deleteStu: "Are you sure from deleting  ",
    addLecture: "Add lecture",
    studentCounts: "Number of students",
    student: "Student",
    evening: "Evening",
    morning: "Morning",
    oneWeek: "Weekly",
    twoWeek: "Every 2 Weeks",
    addGroup: "Add group",
    groupName: "Group name",
    address: "Address",
    privAssistant: "Assistant rules",
    fromHour: "From hour",
    toHour: "To hour",
    groupNameErr: "Enter group name",
    groupAddressErr: "Enter group address",
    fromgroupErr: "Enter the starting hour of the group",
    togroupErr: "Enter the ending hour of the group",
    assisErr: "Enter assistants of the group",
    ruleErr: "Please select at least one rule of assistant",
    dayErr: "Enter the day",
    repeat: "Select one of this (weekly or Every two weeks) ",
    searchPlace: "Search by name, phone, email or username",
    stuLimit: "You can add only 10 students in the free package",
    stuErr: "Please select students of the group",
    editGroup: "Edit group",
    deleteGroup: "Delete group",
    deleteGroupQ: "Do you want to delete this group ?",
    edit: "Edit",
    noGroup: "There's no groups",
    noParent: "There's no parent for this student",
    FromTo: "The starting date must be before the ending date",
    FromToGroup: "The starting date must be before the ending date",
    attendance: "Attendance",
    payment: "Payment",
    paymentPrice : "price per ",
    byMonth: "by month",
    pound : "Pound" ,
    byLecture : "by lecture",
    everySession: "Every Lecture",
    everyMonth: "Every Month",
    seesionPrice: "Lecture Price",
    MonthPrice: "Month Price",
    paymenterror: "Select one of this (Lecture or Every Month) ",
    assistantpermissions: "Assistant's Permissions",
    lecture: "Session",
    notadded: "not added",
    addExam: "Add Exam",
    correctExam: "Correct Exam",
    addStudents: "Add Students",
    asnwerQuestions: "Answer Questions",
    priceWayerror: "Enter Price Value",
    assignRules: "Rules not assigned yet",
    rules: "Rules",
    search: "Search...",
    // General
    next: "Next",
    delete: "Delete",
    loadingFlag: "Loading...",

    // Explanation
    notansweredQues: "Not answered questions",
    videos: "Videos",
    pdfs: "Pocket Book",
    questions: "Questions",
    noChapters: "No Explanations",
    noPDFs: "No pocket book",
    addPDF: " Add pocket book",
    chapter: "Chapter",
    addChapter: "Add chapter",
    lessons: "Lessons",
    noLessons: "No Lessons in this Chapter",
    addLesson: "Add Lesson",
    editPDF: "Edit pocket book",
    deletePDF: "Are you sure tou want to delete pocket book ",
    update: "Edit",
    noVideos: "No Videos",
    addVideo: "Add Video",
    editVideo: "Edit Video",
    deleteVideo: "Are you sure tou want to delete Video",
    deletePDFF: "Delete PDF",
    editChapter: "Edit Chapter",
    deleteChapter: "Are you sure you want to delete chapter",
    EditLesson: "Edit Lesson",
    deleteSubject: "Delete Subject will delete all material you add it to ",
    editSubject: "Edit Subject",
    activate: "Active",
    deleteExam: "Are you sure you want to delete ",
    // Students
    allStudents: "All Students",
    filterArrange: "Arrange",
    filterLevel: "Level",
    filterSubject: "Subject",
    studentname: "Student",
    studentlevel: "Level",
    studentsubject: "Subject",
    Stdresults: "Results",
    sendMSG: "Send Messages",
    fatherInfo: "Father's Information",
    send: "Send",
    noparents: "No Information",
    arrangeAscendant: "A to Z",
    arrangeDescending: "Z to A",
    noStudents: "There are no Students",
    attendanceSTD: "Attendance",
    paymentSTD: "Payment",
    attendList: "Attendance List",
    Payment: "Payment",
    month: "Month",
    state: "State",
    money: "Money",
    sendpay: "Recieve Payment",
    sendnotifpay: "Send Notification",
    noPayment: "There is no months to pay",
    deleteStudent: "Do you want to delete this student ?",
    deleteStudentacc: "Delete Student",
    examName: "Exam Name",
    examType: "Exam Type",
    Result: "Result",
    Total: "Total",
    studentResults: "Levels - Results",
    gradeErr: "There's grade grater than total grade",

    // Exams
    oflineExams: "Offline Exams",
    onlineExams: "Online Exams",
    groupErr: "Please select at least one group",
    chooseQ: "Choose the correct answer question",
    textQ: "Essay question",
    trueQ: "True or false question",
    degreeQ: "Degree of question",
    question: "Question",
    mcq: "Choices",
    rightAnswer: "The correct answer",
    ExamPhoto: "Attach photo",
    placeQ: "Enter the question?",
    placeCh1: "First choice",
    placeCh2: "Second choice",
    placeCh3: "Third choice",
    placeCh4: "Forth choice",
    addQ: "Add another question",
    skip: "Skip",
    Before: 'Before',
    degreeErr: "Please enter the degree of question",
    quesErr: "Please enter at least one question",
    checkErr: "Please check the choices, There are similar choices ",
    true: "True",
    false: "False",
    totalDegree: "Total of degrees",
    titleQues: "Title of questions",
    attendance: "Attendance",
    yesAttend: "Attended",
    noAttends: "Did not attend",
    result: "Result",
    attendErr: "Attendance is required",
    noExams: "There's no Exams",
    noResults: "There's no Results",
    chooseAnswer: "Choose",
    notCoreected: "notCorrected",
    correctResult: "Correct",
    answer: "Answer",
    questionMarkHint: "Grade Per Point",
    top10: "Top",
    recordQues: 'Choose a sound file:',
    showRecoed: "Show the sound file",
    compQ: "Complete question",
    pointsQues: "Are there points at the beginning of the question?",
    addPoints: "Add points...",
    continueQues: "Continue the question",

    //QUESTIONS
    questions: "Questions",
    notanswerQues: "Not answered questions",
    addAnswer: "Add answer",
    addQuestion: "Add Question",
    Question: "Question",
    addQuesError: "Please Enter The Question",
    stuAnswer: "Students' answers",
    publishAnswer: 'Add to the general questions of the lesson : ',
    impAnswer: 'Add to important questions : ',
    allStuAnswer: 'Spread the question to all students',
    yes: 'Yes',
    no: 'No',
    AddBtn: 'Add',
    answerApprove: 'Set as a correct answer',
    important: 'Important',
    AllQues: 'All questions',
    impQues: 'Important',
    notImport: 'Not important',
    getStuAnswer: 'This question has been answered',
    noQues: "There are no questions",
    noAnswr: "There are no answers",

    // All Post
    allPosts: "Posts",
    writePost: "Write Your Post...",
    post: "Post",
    wrtieComment: "Write Your Comment...",
    sendComment: "Send",
    addPostError: "Please Enter your Post",
    allpeople: "All",
    onlyMe: "Only Me",
    Groups: "Groups",
    Subscribers: "Subscribers",
    chooseopt: "Choose",
    editpost: "Edit",
    chooseGroup: "Choose Group",
    addPost: "Add",
    noPosts: "There are no Posts",
    noComments: "There are  no Comments",
    noLikes: "There are  no Likes",
    Likes: "Likes",
    // Attendance
    attmonth: "Month",
    January: "January",
    February: "February",
    March: "March",
    April: 'April',
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: 'November',
    December: "December",
    likeBTN: "Like",
    commentBTN: "Comments",
    noAttend: "No Appointements To Attend",
    okey: "Okey",
    confirmDeletePost: "Are you sure you want to delete post ",

    startChat: "Start chat now",
    //Video
    uploadType: "Upload Type",
    uploadFile: "Upload as file",
    uploadText: "Upload as link",
    //Visitor
    visitor: "Visitor",
    noAppointVisitor: "You must have account to view your appointmwnts",
    //Levels Settings
    LevelsSettings: "Levels Settings",
    noSubLevels: "There's no Sublevels in this Level",
    diactivate: "Not active",
    confirmActivate: "Are you sure you want to add this subLevel",
    confirmDeActivate: "Are you sure you want to delete this subLevel",
    //about us 
    aboutUS: "About Us",
    developedBy: "Designed and Developed by",
    //contact US
    contactUs: "Contact US",
    email: "Email",
    phone: "Phone",
    readMore: "Read More",
    //Attendance
    qrCode: "QR Code",
    noGroupsAttended: "There are no groups today",
    //Common
    explainUn: "Explain",
    examUn: "Exams",
    lessonsUn: "Lessons",
    changeGroupRequest: "Change group requests",

    //group change request 
    fromGroup: "From group : ",
    toGroup: " To group : ",
    transfer: " Transfer",
    refuse: "Refuse",
    refuseConfirm: "Are you sure you want to refuse to move",
    acceptConfirm: "Are you sure you want to accept to move",
    reason: "Reason : ",
    //public search 
    searchResult: "Search result",
    noPublicSearch: "Sorry ther's no search result",
    chapters: "Chapters",
    unchapter: "Chapter",
    pdf: "PDF",
    video: "Video",
    lesson: "Lesson",
    group: "Group",
    assistant: "Assistant",

    //Exerices
    Exerices: "Exercises",
    Exerice: "Exercises",
    noExercies: "There ARE no exercies",
    SelectAll: "Select All",
    anserErrorMSG: "Enter answer to this question",
    minutes: "Minute",
    solvetime: "Solution time",
    theday: "Day",
    // Rules
    Add: "Add",
    Show: "View",
    Edit: "Edit",
    Delete: "Delete",
    editVideo: "edit video",
    deleteeVideo: "delete video",
    EditToDo: "Edit ToDo",
    confirmDeletetodo: "Are You Sure You Want To Delete This ToDo",
    noExams: "There's no exams",
    chooselecture: "Choose Lecture",

    //Dashboard
    teachers: 'Teachers',
    parents: 'Parents',
    subjects: 'Subjects',
    degreeErr: 'Please, Enter all degrees'
  },
  ar: {
    chooselecture: "اختر الحصه",
    noExams: "لايوجد امتحانات",
    confirmDeletetodo: "هل انت متأكد من حذف المهمة",
    EditToDo: "تعديل مهمة",
    //LOGIN
    SignEmail: "البريد الالكتروني",
    SignPass: "كلمة المرور",
    loginBtn: 'تسجيل الدخول',
    signupQues: "ليس لديك حساب؟",
    signup: "الاشتراك",
    forgetQues: "نسيت كلمة المرور؟",
    signinQues: "لديك حساب؟ الدخول",
    viewAsVisitor: "الدخول كزائر",
    chooseLevel: "اختيار المرحلة",
    Continue: "استمرار",
    public: "الكل",
    onlyMe: "انا فقط",
    defult: "اختر الخصوصية",

    // Header
    LogoutBTN: "تسجيل الخروج",
    ArabicBTN: "عربي",
    EnglishBTN: "انجليزي",
    loadBTN: "مشاهدة الكل",
    AllNotifications: "جميع الاشعارات",
    SearchInput: "بحث",
    JoinBTN: "اشتراك",
    noMessages: "لا يوجد رسائل",
    noNotifications: "لا يوجد اشعارات",
    logout: "تسجيل الخروج",
    confirmation: "تأكيد تسجيل الخروج",
    confirm: "تسجيل الخروج",
    CancelBTN: "إلغاء",
    accept: "قبول",
    reject: "رفض",
    // DatesSideNav
    Dates: "المواعيد",
    Saturday: "السبت",
    Sunday: "الاحد",
    Monday: "الاتنين",
    Tuesday: "الثلاثاء",
    Wednesday: "الاربعاء",
    Thursday: "الخميس",
    Friday: "الجمعة",
    day: "اليوم",

    // AccoutnSideNav
    AccountBTN: "حسابي",
    Buslist: "قائمة الاعمال",
    Level: "المراحل",
    stlevel: "الاول الثانوي",
    ndlevel: "الثاني الثانوي",
    thlevel: "الثالث الثانوي",
    addlevel: "اضافة مرحلة",
    Students: "الطلاب",
    Assistants: "المساعدين",
    Settings: "الاعدادات",

    // Levels
    LevelName: "المرحلة",
    groups: "المجموعات",
    exams: "الامتحانات",
    explain: "الشرح",
    AddSubject: "اضافة مادة",
    subject: "المادة",
    submit: "اضافة",
    noSubject: "لا يوجد مواد",

    //ASSISTANTS
    Allassistant: "كل المساعدين",
    Assistant: "المساعد",
    addAssistant: "اضافة مساعد",
    sendMessage: "ارسال رسالة",
    EditData: "تعديل بيانات ",
    AddExam: "اضافه امتحانات",
    examCorr: "تصحيح امتحانات",
    EditStudent: "تعديل بيانات طلاب",
    AddStudent: "اضافه طلاب",
    noGroups: "لا يوجد مجموعات مشارك بها",
    editAssistant: "تعديل بيانات مساعد",
    save: "حفظ",
    deleteAssis: "حذف المساعد",
    deleteAssisQ: "هل تريد حذف هذا المساعد ؟",
    noAssistant: "لا يوجد مساعدين",

    // Settings
    settingsTitle: "الاعدادات",
    personalinformation: "البيانات الشخصية",
    changePassword: "تغير كلمة المرور",
    deleteAccount: "حذف الحساب",
    SaveSettings: "حفظ التعديلات",
    confirmDelete: "هل انت متاكد من حذف الحساب ؟",
    cancelBTN: "الغاء",
    confirmBTN: "حذف",
    myAccount: "حسابي",
    followersNum: "المتابعين",
    notesNum: "المذكرات",
    VideosNum: "الفيديوهات",
    QuestionsNum: "الاسئلة",
    deleteMsg: "الحذف",

    // ToDo
    myToDoTitle: "قائمة أعمالى",
    AddToDo: "إضافة مهمة",
    add: "إضافة",
    confirmFinishTask: "هل أنت متأكد من انهاء المهمة ",
    confirmUnFinishTask: "هل أنت متأكد من إلغاء انهاء المهمة",
    finish: "إنهاء",
    unfinish: "إلغاء انهاء",
    questionMark: "؟",
    tasksExist: "لا يوجد مهام يجب انهائها اليوم",
    AllassistantToDO: "قائمة أعمال المساعدين",
    finished: "منتهية",
    notFininshed: "غير منتهية",
    errorMsg: "من فضلك اختار المساعدين المراد اضافة مهام لهم",
    lectApp: "موعد حصة",
    examApp: "موعد امتحان",
    noAppoint: "لا يوجد مواعيد",
    AllStudentsToDo: "قائمة أعمال الطلاب",
    student: "الطالب",
    noAttends: "لم يحضر",

    // GROUPs
    chooseAssistant: "اختار مساعد",
    students: 'الطلاب',
    assistants: 'المساعدون',
    extraLec: 'حصة اضافية',
    details: 'التفاصيل',
    parent: "ولي امر",
    results: "النتائج",
    conversation: "المحادثة",
    moveGroup: "نقل المجموعة",
    deleteStu: "هل انت متأكد من حذف  ",
    addLecture: "اضافة حصة",
    studentCounts: "عدد الطلاب",
    student: "طالب",
    evening: "مساء",
    morning: "صباحا",
    oneWeek: "اسبوعي",
    twoWeek: "كل اسبوعين",
    addGroup: "اضافة مجموعة",
    groupName: "اسم المجموعة",
    address: "العنوان",
    privAssistant: "صلاحيات المساعد",
    fromHour: "من الساعه",
    toHour: "الى الساعه",
    groupNameErr: "ادخل اسم المجموعة",
    groupAddressErr: "ادخل عنوان المجموعة",
    fromgroupErr: "ادخل وقت بداية المجموعة",
    togroupErr: "ادخل وقت انتهاء المجموعة",
    assisErr: "ادخل مساعدين المجموعة",
    ruleErr: "من فضلك اختر على الاقل واحد من صلاحيات المساعد",
    dayErr: "ادخل اليوم",
    repeat: "(يرجى الاختيار (كل اسبوع او كل اسبوعين",
    searchPlace: "بحث بالاسم او الهاتف او البريد الالكتروني او اسم المستخدم",
    stuLimit: "يمكنك اضافه 10 طلاب فقط في الباقه المجانيه",
    stuErr: "يرجى اختيار طلاب المجموعة",
    editGroup: "تعديل المجموعة",
    deleteGroup: "حذف المجموعة",
    deleteGroupQ: "هل تريد حذف هذه المجموعة ؟",
    edit: "تعديل",
    noGroup: "لا يوجد مجموعات",
    noParent: "لا يوجد ولي امر لهذا الطالب",
    FromTo: " وقت بداية الامتحان يجب ان يكون قبل وقت نهاية الامتحان",
    FromToGroup: "وقت البداية  يجب ان يكون قبل وقت النهاية ",
    attendance: "الحضور",
    payment: "الدفع",
    byMonth: "للشهر ",
    pound : "جنيه" ,
    byLecture : "للحصه",
    everySession: "كل حصة",
    everyMonth: "كل شهر",
    seesionPrice: "سعر الحصة",
    MonthPrice: "سعر الشهر",
    paymenterror: "(يرجى الاختيار (كل حصة او كل شهر",
    assistantpermissions: "صلاحيات المساعد",
    lecture: "الحصة ",
    notadded: "لم يتم تحديده",
    addExam: "اضافة امتحان",
    correctExam: "تصحيح امتحان",
    addStudents: "اضافة طلاب",
    asnwerQuestions: "اجابة اسئلة",
    priceWayerror: "ادخل السعر",
    assignRules: "لم يتم تعيين صلاحيات بعد",
    rules: "الصلاحيات",
    search: 'بحث...',
    // General
    next: "التالى",
    delete: "حذف",
    loadingFlag: "جارى التحميل...",
    // Explanation
    notansweredQues: "الاسئلة الغير مجاب عنها",
    videos: "الفيديوهات",
    pdfs: "المذكرات",
    questions: "الاسئلة",
    noChapters: "لا يوجد شرح",
    noPDFs: "لا يوجد مذكرات",
    addPDF: "اضافة مذكرة",
    chapter: "الفصل",
    addChapter: "اضافة فصل",
    lessons: "الدروس",
    noLessons: "لايوجد دروس فى هذا الفصل",
    addLesson: "إضافة درس",
    editPDF: "تعديل المذكرة",
    deletePDF: "هل أنت متأكد من حذف المذكرة ",
    update: "تعديل",
    noVideos: "لا يوجد فيديوهات",
    addVideo: "إضافة فيديو",
    editVideo: "تعديل فيديو",
    deleteVideo: "هل أنت متأكد من حذف الفيديو ",
    deletePDFF: "حذف المذكرة",
    editChapter: "تعديل الفصل",
    deleteChapter: "هل انت متأكد من حذف فصل",
    EditLesson: "تعديل الدرس",
    deleteSubject: "هل أنت متأكد من الحذف ..ذلك سوف يؤدى الى حذف كل الشرح والمجموعات الموجودة ب",
    editSubject: "تعديل المادة",
    activate: "تفعيل",
    deleteExam: "هل أنت متأكد من حذف ",
    // Students
    allStudents: "كل الطلاب",
    filterArrange: "ترتيب",
    filterLevel: "المرحلة",
    filterSubject: "المادة",
    studentname: "الطالب",
    studentlevel: "المرحلة",
    studentsubject: "المادة",
    Stdresults: "النتائج",
    sendMSG: "ارسال رسالة",
    fatherInfo: "بيانات ولي الامر",
    send: "ارسال",
    noparents: "لا يوجد بيانات",
    arrangeAscendant: "أ إلى ى",
    arrangeDescending: "ى إلى أ",
    noStudents: "لا يوجد طلاب",
    attendanceSTD: "الحضور",
    paymentSTD: "الدفع",
    attendList: "سجل الحضور",
    Payment: "الدفع",
    month: "الشهر",
    state: "الحالة",
    money: "المبلغ",
    sendnotifpay: "ارسال اشعار ",
    sendpay: "استلام المبلغ",
    noPayment: "لا يوجد شهور للدفع",
    paymentPrice: "سعر الدفع",
    deleteStudent: "هل تريد حذف هذا الطالب ؟",
    deleteStudentacc: "حذف الطالب",
    examName: "اسم الامتحان",
    examType: "نوع الامتحان",
    Result: "النتيجة",
    Total: "الاجمالي",
    studentResults: "المراحل - النتائج",
    gradeErr: "يوجد درجة اكبر من الدرجة الكلية",

    // Exams
    oflineExams: " امتحانات أثناء الحصة",
    onlineExams: " امتحانات عبر الانترنت",
    groupErr: "يرجى اختيار مجموعة على الاقل",
    chooseQ: "سؤال اختر الاجابه الصحيحه",
    trueQ: "سؤال صح ام خطأ",
    textQ: "السؤال المقالي",
    degreeQ: "درجة السؤال",
    question: "السؤال",
    mcq: "الاختيارات",
    rightAnswer: "الاجابه الصحيحه",
    ExamPhoto: "ارفق صورة",
    placeQ: "ادخل السؤال",
    placeCh1: "الاختيار الأول",
    placeCh2: "الاختيار الثاني",
    placeCh3: "الاختيار الثالث",
    placeCh4: "الاختيار الرابع",
    addQ: "اضافه سؤال اخر",
    skip: "تخطي",
    Before: 'السابق',
    degreeErr: "يرجى ادخال درجة السؤال",
    quesErr: "يرجى ادخال سؤال على الاقل",
    checkErr: "يوجد اختيارات متشابهة",
    true: "صحيحه",
    false: "خطأ",
    totalDegree: " إجمالي الدرجات",
    titleQues: "عنوان الاسئلة",
    attendance: "الحضور",
    yesAttend: "حضر",
    noAttend: "لم يحضر",
    result: "النتيجه",
    attendErr: "يجب ادخال الحضور",
    noExams: "لا يوجد امتحانات",
    noResults: "لا يوجد نتائج",
    chooseAnswer: "اختر",
    notCoreected: "لم يُصحح",
    correctResult: "تصحيح",
    answer: "الاجابة",
    questionMarkHint: "الدرجة لكل نقطة",
    top10: "الاوائل",
    recordQues: 'اختر ملف الصوت:',
    showRecoed: 'عرض ملف الصوت',
    compQ: "سؤال اكمل",
    pointsQues: " هل يوجد نقاط فى بداية السؤال ؟",
    addPoints: " اضف نقاط...",
    continueQues: "تكملة السؤال",

    //QUESTIONS
    questions: "الاسئلة",
    notanswerQues: "الاسئلة الغير مجاب عنها",
    addAnswer: "إضافه اجابه",
    addQuestion: "اضافة سؤال",
    Question: "السؤال",
    addQuesError: "من فضلك ادخل السؤال",
    stuAnswer: 'إجابات الطلاب',
    publishAnswer: 'إضافه الى الاسئلة العامه للدرس :',
    impAnswer: 'إضافه الى الاسئلة المهمه :',
    allStuAnswer: 'نشر السؤال لجميع الطلاب',
    yes: 'نعم',
    no: 'لا',
    AddBtn: 'إضافه',
    answerApprove: 'تعيين كأجابه صحيحه',
    important: 'مهم',
    AllQues: 'كل الاسئلة',
    impQues: 'مهمة',
    notImport: 'غير مهمة',
    getStuAnswer: 'تم الاجابة على هذا السؤال',
    noQues: 'لا يوجد اسئلة',
    noAnswr: 'لا يوجد اجابات',

    // All Post
    allPosts: "المنشورات",
    writePost: "اكتب منشورك...",
    post: "انشر",
    wrtieComment: "اكتب نعليقك...",
    sendComment: "ارسال",
    addPostError: "من فضلك اكتب منشورك",
    allpeople: "الكل",
    onlyMe: "لي فقط",
    Groups: "المجموعات",
    Subscribers: "المشتركين",
    chooseopt: "اختار",
    editpost: "تعديل",
    chooseGroup: "اختار الجروب",
    addPost: "اضافة",
    noPosts: "لا يوجد منشورات",
    noComments: "لا يوجد تعليقات",
    noLikes: "لا يوجد تعليقات",
    Likes: "الاعجابات",

    // Attendance
    attmonth: "شهر",
    January: "يناير",
    February: "فبراير",
    March: "مارس",
    April: 'أبريل',
    May: "مايو",
    June: "يونيه",
    July: "يوليو",
    August: "أغسطس",
    September: "سبتمبر",
    October: "أكتوبر",
    November: 'نوفمبر',
    December: "ديسمبر",
    likeBTN: "اعجبني",
    commentBTN: "التعليقات",
    noAttend: "لا يوجد مواعيد للحضور ",
    okey: "",
    startChat: "ابدأ المحادثة",
    //Video
    uploadType: "تحميل الفيديو",
    uploadFile: "تحميل ملف",
    uploadText: "تحميل رابط",
    //Visitor
    visitor: "زائر",
    noAppointVisitor: "لا يوجد مواعيد - يجب الشتراك اولا",
    //Levels Settings
    LevelsSettings: "إعدادات المراحل",
    noSubLevels: "لا يوجد صفوف دراسية فى هذه المرحلة",
    diactivate: "إلغاء التفعيل",
    confirmActivate: "هل أنت متأكد من اضافة وتفعيل الصف الدراسى ",
    confirmDeActivate: "هل أنت متأكد من حذف وإلغاء تفعيل الصف الدراسى ",
    //about US
    aboutUS: "عن التطبيق",
    developedBy: "تم التطوير والتصمييم بواسطة",
    //contact US
    contactUs: "اتصل بنا",
    email: "البريد الالكترونى",
    phone: "الهاتف",
    confirmDeletePost: "هل انت متأكد من حذف منشور",
    readMore: "المزيد",
    qrCode: "فحص الكود",
    noGroupsAttended: "لا يوجد مجموعات اليوم",

    //Common
    explainUn: "شرح",
    examUn: "امتحانات",
    lessonsUn: "دروس",
    changeGroupRequest: "طلبات تغيير المجموعة",
    //group change request 
    fromGroup: "من مجموعة : ",
    toGroup: "إلى مجموعة : ",
    transfer: "نقل",
    refuse: "رفض",
    refuseConfirm: "هل أنت متأكد من رفض طلب نقل ",
    acceptConfirm: "هل أنت متأكدة من قبول طلب نقل",
    reason: "السبب : ",
    //public search 
    searchResult: "نتائج البحث عن ",
    noPublicSearch: "عفوا لا يوجد نتائج بحث",
    chapters: "الفصول",
    unchapter: "فصل",
    pdf: "مذكرة",
    video: "فيديو",
    lesson: "درس",
    group: "مجموعة",
    assistant: "مساعد",
    Exerices: "تمرينات عامة ",
    Exerice: "التمرين",
    noExercies: "لا يوجد تمرينات عامة",
    SelectAll: "تحديد الكل",
    anserErrorMSG: "اضف اجابة لهذا السؤال",
    minutes: "دقيقة",
    solvetime: "وقت الحل",
    theday: "يوم",
    // Rules
    Add: "إضافة",
    Show: "عرض",
    Edit: "تعديل",
    Delete: "حذف",
    editVideo: "تعديل الفيديو",
    deleteeVideo: "حذف الفيديو",

    //Dashboard
    teachers: 'المدرسين',
    parents: 'اولياء الامور',
    subjects: 'المواد الدراسية',
    degreeErr: 'يجب ادخال جميع الدرجات',
  }
});

export default strings;